"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const markty_toml_1 = __importDefault(require("markty-toml"));
const jsonlint_browser_1 = require("../../forked-vendors/jsonlint.browser");
function stripJSONComments(jsonString) {
    return jsonString.replace(/\\"|"(?:\\"|[^"])*"|(\/\/.*|\/\*[\s\S]*?\*\/)/g, (m, g) => (g ? '' : m));
}
function getCode(template, module, sandbox, resolveModule, configurationFile) {
    if (module) {
        return { code: module.code, generated: false };
    }
    if (configurationFile.getDefaultCode) {
        return {
            code: configurationFile.getDefaultCode(template, resolveModule),
            generated: true,
        };
    }
    if (sandbox && configurationFile.generateFileFromSandbox) {
        return {
            code: configurationFile.generateFileFromSandbox(sandbox),
            generated: true,
        };
    }
    return { code: '', generated: false };
}
function titleIncludes(module, test) {
    if ('title' in module) {
        return module.title.includes(test);
    }
    if ('path' in module) {
        return module.path.includes(test);
    }
    return false;
}
/**
 * We convert all configuration file configs to an object with configuration per
 * type. This makes configs universal.
 */
function parseConfigurations(template, configurationFiles, resolveModule, sandbox) {
    const configurations = {};
    const paths = Object.keys(configurationFiles);
    for (let i = 0; i < paths.length; i++) {
        const path = paths[i];
        const module = resolveModule(path);
        const configurationFile = configurationFiles[path];
        const baseObject = Object.assign({ path }, getCode(template, module, sandbox, resolveModule, configurationFile));
        const { code } = baseObject;
        if (code) {
            try {
                let parsed;
                // it goes here three times and the third time it doesn't have a title but a path
                // that took a while ffs
                // if toml do it with toml parser
                if (module && titleIncludes(module, 'toml')) {
                    // never throws
                    parsed = (0, markty_toml_1.default)(code);
                }
                else if (module && titleIncludes(module, 'tsconfig.json')) {
                    parsed = (0, jsonlint_browser_1.parse)(stripJSONComments(code));
                }
                else {
                    parsed = (0, jsonlint_browser_1.parse)(code);
                }
                configurations[configurationFile.type] = Object.assign(Object.assign({}, baseObject), { parsed });
            }
            catch (e) {
                configurations[configurationFile.type] = Object.assign(Object.assign({}, baseObject), { error: e });
            }
        }
    }
    return configurations;
}
exports.default = parseConfigurations;
